import { CRBattles } from '@/routes/cr/CRBattles';

/**
 * My battles — the existing CR screen, rendered in place instead of navigated to.
 *
 * ⚠️ `embedded` non e' un dettaglio di stile: dice a `CRBattles` che qui **l'URL non e' il suo**.
 * Senza, un utente senza account collegato veniva mandato fuori dalla Hub con un `replace` che
 * cancellava l'unica voce di history — e restava chiuso fuori (segnalato da Luca il 2026-09-10).
 * Chi monta una ROTTA dentro un pannello si prende anche le sue navigazioni.
 */
export function BattlesPanel() {
  return (
    // -mx-4 cancels the Hub padding: <CRBattles /> brings its own px-4.
    <div className="-mx-4 h-full">
      <CRBattles embedded />
    </div>
  );
}
